import { EventCategory } from "./event";
//An array of EventCategories that are able to generate Alerts
export const alertEventCategories = [
    EventCategory.WearableAlert,
    EventCategory.DeviceConnect,
    EventCategory.DeviceDisconnect,
    EventCategory.LowBattery,
    EventCategory.DeviceProvision,
    EventCategory.EnvironmentThreshold,
    EventCategory.GeofenceEntered,
    EventCategory.GeofenceExited,
    EventCategory.Shock,
    EventCategory.SiteEntered,
    EventCategory.SiteExited,
    EventCategory.InventoryAdded,
    EventCategory.InventoryRemoved,
    EventCategory.CustomEvent,
];
//# sourceMappingURL=alert.js.map